export default __webpack_public_path__ + "static/media/b5.33bf443a.jpg";